import cn from 'classnames';
import { Text } from '@/shared/ui/core';
import { CheckIcon, XIcon } from '@phosphor-icons/react/dist/ssr';
import { PasswordLevel } from '@/shared/ui/kit/password-strength/lib/use-password-strength';
import { PasswordStrengthProps } from '@/shared/ui/kit/password-strength';
import styles from './password-strength.module.scss';


const SEGMENTS: number                              = 4;
const LEVEL_SEGMENTS: Record<PasswordLevel, number> = {
    empty : 0,
    weak  : 1,
    medium: 2,
    strong: 4,
};


export function PasswordStrength ({ level, rules, touched, hint, className }: PasswordStrengthProps) {
    const filledSegments = touched ? LEVEL_SEGMENTS[level] : 0;
    const activeLevel    = touched ? level : 'empty';

    return (
        <div className={ cn(styles.root, className) }>

            <div className={ styles.bar }>
                <Text
                    as="span"
                    size="sm"
                    tone="secondary"
                >
                    Password strength
                </Text>

                <span className={ styles.segments }>
                    {
                        Array.from({ length: SEGMENTS }).map((_, i) => (
                            <span
                                key={ i }
                                className={ cn(styles.segment, {
                                    [styles[`segment_${ activeLevel }`]]: i < filledSegments,
                                    [styles.segment_empty]              : i >= filledSegments,
                                }) }
                            />
                        ))
                    }
                </span>
            </div>

            <div className={ styles.rules_wrapper }>
                <Text
                    as="p"
                    size="lg"
                    tone="primary"
                >
                    { hint }
                </Text>

                <ul className={ styles.rules }>
                    {
                        rules.map((rule) => {
                            const failedTone = touched && !rule.passed ? 'destructive' : undefined;
                            const passedTone = touched && rule.passed ? 'success' : 'secondary';
                            const tone       = failedTone ?? passedTone;

                            return (
                                <li
                                    key={ rule.id }
                                    className={ cn(styles.rule, {
                                        [styles.rule_passed]   : touched && rule.passed,
                                        [styles.rule_failed]   : touched && !rule.passed,
                                        [styles.rule_untouched]: !touched,
                                    }) }
                                >
                                    {
                                        touched && rule.passed
                                            ? <CheckIcon size={ 16 }/>
                                            : <XIcon size={ 16 }/>
                                    }
                                    <Text
                                        as="span"
                                        size="md"
                                        tone={ tone }
                                    >
                                        { rule.label }
                                    </Text>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        </div>
    );
}
